import { CAPABILITIES } from "@/data/content";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { Stagger, Item } from "@/components/shared/Reveal";
import { Icon } from "@/components/shared/Icon";

export const WhatWeDo = () => (
  <section data-testid="what-we-do-section" className="section relative">
    <div className="wrap grid gap-14 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <SectionHeading
          eyebrow="What Wexoz does"
          title="We connect the technology behind transportation."
          text="Transportation operations increasingly depend on multiple technologies — vehicle tracking, sensors, cameras, fleet platforms, route optimization, driver applications, AI and operational systems. Wexoz brings these technologies together into a connected solution designed around each customer's specific requirements."
        />
      </div>
      <Stagger className="lg:col-span-7 grid divide-y divide-line border-y border-line">
        {CAPABILITIES.map((c) => (
          <Item key={c.id} data-testid={`capability-${c.title.toLowerCase()}`} className="group grid grid-cols-[auto_1fr] items-start gap-6 py-7 sm:grid-cols-[64px_180px_1fr] sm:items-center">
            <span className="font-mono text-xs text-slate-500">{c.id}</span>
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg border border-line bg-navy-800 text-cyan-400 transition-colors group-hover:border-cyan-400/50">
                <Icon name={c.icon} className="h-4 w-4" />
              </span>
              <h3 className="font-heading text-xl font-semibold">{c.title}</h3>
            </div>
            <p className="col-span-2 text-sm leading-relaxed text-slate-400 sm:col-span-1">{c.text}</p>
          </Item>
        ))}
      </Stagger>
    </div>
  </section>
);
